export default "__VITE_ASSET__Cyxmjnkp__"